const NAMESPACE = 'COLLABORATE';
const ACTIONS = {
    COLLABORATE: `${NAMESPACE}_COLLABORATE`,
    FETCH_COUNT: `${NAMESPACE}_FETCH_COUNT`,
    FETCH_COUNT_START: `${NAMESPACE}_FETCH_COUNT_START`,
    FETCH_COUNT_SUCCESS: `${NAMESPACE}_FETCH_COUNT_SUCCESS`,
    FETCH_COUNT_ERROR: `${NAMESPACE}_FETCH_COUNT_ERROR`,
    FETCH_INVITE: `${NAMESPACE}_FETCH_INVITE`,
    FETCH_INVITE_ERROR: `${NAMESPACE}_FETCH_INVITE_ERROR`,
    FETCH_INVITE_START: `${NAMESPACE}_FETCH_INVITE_START`,
    FETCH_INVITE_SUCCESS: `${NAMESPACE}_FETCH_INVITE_SUCCESS`,
    FETCH_LOGIN: `${NAMESPACE}_FETCH_LOGIN`,
    FETCH_LOGIN_ERROR: `${NAMESPACE}_FETCH_LOGIN_ERROR`,
    FETCH_LOGIN_START: `${NAMESPACE}_FETCH_LOGIN_START`,
    FETCH_LOGIN_SUCCESS: `${NAMESPACE}_FETCH_LOGIN_SUCCESS`,
    RESET: `${NAMESPACE}_RESET`
};

/* istanbul ignore next */
const ACTION_CREATORS = {
    collaborate: () => ({type: ACTIONS.COLLABORATE}),
    fetchCount: (boardId) => ({type: ACTIONS.FETCH_COUNT, payload: {boardId}}),
    invite: (boardId) => ({type: ACTIONS.FETCH_INVITE, payload: {boardId}}),
    login: (fullLocale, siteName) => ({type: ACTIONS.FETCH_LOGIN, payload: {fullLocale, siteName}}),
    reset: () => ({type: ACTIONS.RESET})
};

export default {...ACTIONS, ...ACTION_CREATORS};



// WEBPACK FOOTER //
// ./src/universal/tripboard/collaborate/actions.js